export const APP_ID = import.meta.env.VITE_APP_ID as string
export const IMAGE_CDN = import.meta.env.VITE_IMAGE_CDN as string
export const BASE_URL = import.meta.env.VITE_APP_BASE_URL as string

export const TOKEN_KEY = 'gibbous-web-token'
export const SESSION_KEY = 'gibbous-web-session'
export const USER_ID_KEY = 'gibbous-web-uid'
export const USER_NAME_KEY = 'gibbous-web-uname'
export const USER_AVATAR_KEY = 'gibbous-web-avatar'
export const LANG_KEY = 'gibbous-web-lang'
export const LONGITUDE_KEY = 'gibbous-web-lng'
export const LATITUDE_KEY = 'gibbous-web-lat'
